import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {
  Lightbox,
  LightboxConfig,
  IAlbum
} from 'angular2-lightbox';
import { Image } from '../../../models';
import { LocaleAwareBaseComponent } from './../../../seo/locale-aware-base.component';
import { ListTrackingService } from './../../../utils/list-tracking.service';

@Component({
  selector: 'app-images-carousel-base',
  templateUrl: './images-carousel-base.component.html',
  styleUrls: ['./images-carousel-base.component.scss']
})

export class ImagesCarouselBaseComponent extends LocaleAwareBaseComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('thumbnailsView') thumbnailsView: ElementRef;
  @ViewChild('thumbnailsList') thumbnailsList: ElementRef;

  @Input('images')
  set images(images: Image[]) {
    this._images = images;
    this._albums = [];

    for (const image of images) {
      const album = {
          src: image.url,
          caption: image.title,
          thumb: image.width_560_url
      };

      this._albums.push(album);
    }
  }
  get images(): Image[] {
    return this._images;
  }
  _images: Image[] = [];

  @Output() emitSlideChange: EventEmitter<any> = new EventEmitter<any>();
  private autoSlideInterval: number = 7000;
  private autoSlideTimer: any;
  private _albums: IAlbum[];
  private scrollPosCanChange: boolean = false;
  private thumbnailsScrollVals: number[] = [];
  public isAutoSlideActive: boolean = true;
  public thumbnailsListWidth: number;
  public currentSlideNumber: number;
  public zoomImageParams: any;
  public isZoomDisabled: boolean = false;

  constructor(
    private _lightbox: Lightbox,
    private _lighboxConfig: LightboxConfig,
    public listTrackingService: ListTrackingService,
    @Inject('WINDOW') private window: any
  ) {
    super();
    this.refreshTimer();
  }

  ngOnInit(): void {
    this.currentSlideNumber = 0;
    this.onSlideChange(this.currentSlideNumber);
    this.initLightbox(this.images);
    this.thumbnailsListWidth = this.images.length * 140;
  }

  ngOnChanges(): void  {
    // this.initLightbox(this.images);

    // if (this.images[0])
      // this.updateCurrentSlide(0, undefined);
  }

  ngAfterViewInit(): void {
    if (this.images.length > 1) {
      this.setThumbnailsScrollVals(140);
      this.setThumbnailsListScrollPosition();
      this.scrollPosCanChange = true;
    }
  }

  private setThumbnailsScrollVals(thumbWidth: number): void {
    const imgNr = this.images.length;
    const centerElem = Math.floor(imgNr / 2);

    let centerScrollVal = 0;

    if (this.thumbnailsView)
      centerScrollVal = Math.abs(
        this.thumbnailsView.nativeElement.offsetWidth / 2 - this.thumbnailsListWidth / 2);
    else
      this.scrollPosCanChange = false;

    if (imgNr > 1)
      for (let i = 0; i <= imgNr; i++)
        if (imgNr % 2 === 0) {
          if (i <= centerElem)
            this.thumbnailsScrollVals[i] = centerScrollVal - (thumbWidth / 2) - (centerElem - i - 1) * thumbWidth;
          else
            this.thumbnailsScrollVals[i] = centerScrollVal + (thumbWidth / 2) + (i - centerElem) * thumbWidth;
        } else {
          if (i < centerElem)
            this.thumbnailsScrollVals[i] = centerScrollVal - (centerElem - i) * thumbWidth;
          else if (i > centerElem)
            this.thumbnailsScrollVals[i] = centerScrollVal + (i - centerElem) * thumbWidth;
          else
            this.thumbnailsScrollVals[i] = centerScrollVal;
        }
  }

  private setThumbnailsListScrollPosition(slideNumber?: number): void {
    if (this.images.length > 1 && this.thumbnailsList)
      if (!slideNumber)
        this.thumbnailsList.nativeElement.scrollLeft = 0;
      else
        this.thumbnailsList.nativeElement.scrollLeft = this.thumbnailsScrollVals[slideNumber];
  }

  public open(index: number, event: any): void {
    if (event)
      event.stopPropagation();

    if (this.window)
      this._lighboxConfig.positionFromTop = 20;

    this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
  }

  private startAutoRotation(): void {
    if (this.images.length > 1)
      if (this.window)
        this.autoSlideTimer = setInterval(
          () => {
            if (this.isAutoSlideActive) {
              this.getNext(undefined);
            }
          },
          this.autoSlideInterval
        );
  }

  private initLightbox(images: Image[]): void {
    this._lighboxConfig.fadeDuration = 1;
  }

  private refreshTimer(): void {
    clearInterval(this.autoSlideTimer);

    this.startAutoRotation();
  }

  private onSlideChange(slideNumber: number): void {
    this.emitSlideChange.emit({
      imageUrl: this.images[slideNumber].url,
      slideNumber: slideNumber
    });
  }

  updateCurrentSlide(slideNumber: number, event: any): void {
    if (event)
      event.stopPropagation();

    this.currentSlideNumber = slideNumber;
    this.onSlideChange(this.currentSlideNumber);
    this.refreshTimer();

    if (this.window)
      // Same as hover-scroll.directive (should not interfere)
      if (this.window.innerWidth < 600)
        this.updateThumbnailsListScrollPosition(slideNumber);
  }

  private updateThumbnailsListScrollPosition(slideNumber: number): void {
    if (this.scrollPosCanChange && this.images.length > 1)
      this.setThumbnailsListScrollPosition(slideNumber);
  }

  public getPrevious(event: any): void {
    if (event)
      event.stopPropagation();

    if (this.currentSlideNumber === 0)
      this.currentSlideNumber = this.images.length - 1;
    else
      this.currentSlideNumber--;

    this.onSlideChange(this.currentSlideNumber);
    this.refreshTimer();

    this.updateThumbnailsListScrollPosition(this.currentSlideNumber);
  }

  public getNext(event: any): void {
    if (event)
      event.stopPropagation();

    if (this.currentSlideNumber === this.images.length - 1)
      this.currentSlideNumber = 0;
    else
      this.currentSlideNumber++;

    this.onSlideChange(this.currentSlideNumber);
    this.refreshTimer();

    this.updateThumbnailsListScrollPosition(this.currentSlideNumber);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/images-carousel-base/images-carousel-base.component.ts